<script lang="ts">
  import { t } from '../i18n/index.svelte';
  import { studio } from '../state.svelte';
  import Section from './ui/Section.svelte';

  let { size, fixedAspect }: { size: [number, number]; fixedAspect: boolean } = $props();

  const presets: [number, number][] = [
    [1280, 720],
    [1920, 1080],
    [1080, 1080],
    [1024, 768],
    [2560, 1440],
  ];
</script>

<Section title={t('output.title')}>
  {#if fixedAspect}
    <label class="field">
      <span>{t('output.maxSide')}</span>
      <select bind:value={studio.output.maxSide}>
        {#each [640, 1024, 1280, 1920, 2560, 3840] as v (v)}<option value={v}>{v}px</option>{/each}
      </select>
    </label>
  {:else}
    <div class="grid2">
      <label class="field"
        ><span>{t('output.width')}</span><input
          type="number"
          min="64"
          max="4096"
          bind:value={studio.output.width}
          data-testid="out-width"
        /></label
      >
      <label class="field"
        ><span>{t('output.height')}</span><input
          type="number"
          min="64"
          max="4096"
          bind:value={studio.output.height}
          data-testid="out-height"
        /></label
      >
    </div>
    <div class="presets">
      {#each presets as [w, h] (`${w}x${h}`)}
        <button class="ghost" onclick={() => ((studio.output.width = w), (studio.output.height = h))}>{w}×{h}</button>
      {/each}
    </div>
  {/if}
  <p class="muted mono small">{t('output.result', { w: size[0], h: size[1] })}</p>
</Section>

<style>
  .field {
    display: flex;
    flex-direction: column;
    gap: 3px;
    font-size: 13px;
  }
  .presets {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }
  .presets button {
    font-size: 12px;
    padding: 3px 8px;
  }
  .small {
    font-size: 12px;
    margin: 0;
  }
</style>
